var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_652_1261",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_652_1261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 13.5V8.5C22 7.1 22.4833 5.91667 23.45 4.95C24.4167 3.98333 25.6 3.5 27 3.5H32V8.5C32 9.9 31.5167 11.0833 30.55 12.05C29.5833 13.0167 28.4 13.5 27 13.5H22ZM11 25.5C9.06667 25.5 7.41667 24.8167 6.05 23.45C4.68333 22.0833 4 20.4333 4 18.5V11.5H11C12.9333 11.5 14.5833 12.1833 15.95 13.55C17.3167 14.9167 18 16.5667 18 18.5V25.5H11ZM32 43.5C30.7 43.5 29.4583 43.3 28.275 42.9C27.0917 42.5 26.0167 41.95 25.05 41.25L23.4 42.9C23.0333 43.2667 22.5667 43.45 22 43.45C21.4333 43.45 20.9667 43.2667 20.6 42.9C20.2333 42.5333 20.05 42.0667 20.05 41.5C20.05 40.9333 20.2333 40.4667 20.6 40.1L22.25 38.45C21.55 37.4833 21 36.4083 20.6 35.225C20.2 34.0417 20 32.8 20 31.5C20 28.1667 21.1667 25.325 23.5 22.975C25.8333 20.625 28.6667 19.45 32 19.45H44.05V31.5C44.05 34.8333 42.875 37.6667 40.525 40C38.175 42.3333 35.3333 43.5 32 43.5ZM32 39.5C34.2333 39.5 36.1167 38.7167 37.65 37.15C39.1833 35.5833 39.95 33.7 39.95 31.5V23.5H32C29.8 23.5 27.9167 24.275 26.35 25.825C24.7833 27.375 24 29.2667 24 31.5C24 32.2667 24.0917 32.9917 24.275 33.675C24.4583 34.3583 24.7333 35 25.1 35.6L30.6 30.1C30.9667 29.7333 31.4333 29.55 32 29.55C32.5667 29.55 33.0333 29.7333 33.4 30.1C33.7667 30.4667 33.95 30.9333 33.95 31.5C33.95 32.0667 33.7667 32.5333 33.4 32.9L27.9 38.4C28.5 38.7667 29.1417 39.0417 29.825 39.225C30.5083 39.4083 31.2333 39.5 32 39.5Z",
    fill: "#ED5272"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFall);
export default __webpack_public_path__ + "static/media/Fall.57b0e7706f7e9a39de439d60adad1ed0.svg";
export { ForwardRef as ReactComponent };